import { z } from 'zod';

export const invoiceItemSchema = z.object({
  description: z.string().min(1, 'Description is required'),
  quantity: z.number().int().min(1),
  unitPrice: z.number().min(0),
});

export const createInvoiceSchema = z.object({
  clientId: z.string(),
  items: z.array(invoiceItemSchema).min(1, 'At least one item is required'),
  taxRate: z.number().min(0).max(100).default(0),
  depositAmount: z.number().min(0).default(0),
  dueDate: z.string().datetime().nullable().optional(),
  notes: z.string().max(5000).nullable().optional(),
  sepayTxnId: z.string().nullable().optional(),
  artifactData: z.unknown().nullable().optional(),
  chatThreadId: z.string().nullable().optional(),
  artifactIndex: z.number().int().nonnegative().nullable().optional(),
});

export const updateInvoiceSchema = createInvoiceSchema.partial();

export type CreateInvoiceInput = z.infer<typeof createInvoiceSchema>;
export type UpdateInvoiceInput = z.infer<typeof updateInvoiceSchema>;

export const sendInvoiceEmailSchema = z.object({
  to: z.string().email(),
  subject: z.string().min(1).max(200),
  body: z.string().min(1).max(5000),
});

export type SendInvoiceEmailInput = z.infer<typeof sendInvoiceEmailSchema>;

export const markSharedSchema = z.object({
  channel: z.enum(['zalo', 'sms', 'other']).default('zalo'),
});

export type MarkSharedInput = z.infer<typeof markSharedSchema>;
